module.exports = __webpack_public_path__ + "2c85713598824860895cb14de6a5247a.pdf";